/**
 * @name ProtectedDashboardPage
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Wrapper protegido para o HomePage que só renderiza se o usuário estiver autenticado
 * @package components/pages/gestao-financeira/dashboard
 */

import { HomePage } from '@/components/pages';
import { useUserContext } from '@/contexts/UserContext';
import React from 'react';

const ProtectedDashboardPage: React.FC = () => {
     const { userSession, userData } = useUserContext();

     // Só renderiza o dashboard se o usuário estiver autenticado
     if (!userSession || !userData) {
          return null; // Retorna null para não renderizar nada
     }

     return <HomePage />;
};

export default ProtectedDashboardPage;
